const accordionSummary = {
  styleOverrides: {
    root: {
      margin: "0.75rem 0",
    },
    content: {
      margin: 0,
      fontSize: "1.6rem",
      alignItems: "center",
    },
  },
};

export default accordionSummary;
